import type { TranslationKey } from '~/shared/internationalization/translation';

const prefix = 'pages.job-architecture-v2.profile-tasks' as const;

export const profileTaskTranslationKeys = {
    addTask: `${prefix}.actions.add-task`,
    addNamedSkill: `${prefix}.actions.add-named-skill`,
    addWorkflowStep: `${prefix}.actions.add-workflow-step`,
    breadcrumb: `${prefix}.breadcrumb`,
    classification: `${prefix}.fields.classification`,
    clusters: `${prefix}.fields.clusters`,
    description: `${prefix}.fields.description`,
    details: `${prefix}.fields.details`,
    draftHint: `${prefix}.draft-hint`,
    draftUnavailableBody: `${prefix}.draft-unavailable.body`,
    draftUnavailableTitle: `${prefix}.draft-unavailable.title`,
    editTask: `${prefix}.actions.edit-task`,
    effort: `${prefix}.fields.effort`,
    effortFormat: `${prefix}.fields.effort-format`,
    empty: `${prefix}.empty`,
    errorBody: `${prefix}.errors.body`,
    errorTitle: `${prefix}.errors.title`,
    loading: `${prefix}.loading`,
    manuallyEdited: `${prefix}.fields.manually-edited`,
    maximumEffort: `${prefix}.fields.maximum-effort`,
    minimumEffort: `${prefix}.fields.minimum-effort`,
    moveDown: `${prefix}.actions.move-down`,
    moveUp: `${prefix}.actions.move-up`,
    reasoningInfo: `${prefix}.fields.reasoning-info`,
    reorderTask: `${prefix}.actions.reorder-task`,
    searchSkills: `${prefix}.actions.search-skills`,
    removeSkill: `${prefix}.actions.remove-skill`,
    removeTask: `${prefix}.actions.remove-task`,
    removeWorkflowStep: `${prefix}.actions.remove-workflow-step`,
    skills: `${prefix}.fields.skills`,
    title: `${prefix}.title`,
    taskTitle: `${prefix}.fields.title`,
    unknownClassification: `${prefix}.classification.unknown`,
    viewTask: `${prefix}.actions.view-task`,
    workflow: `${prefix}.fields.workflow`,
    workflowStepDescription: `${prefix}.fields.workflow-step-description`,
    workflowStepTitle: `${prefix}.fields.workflow-step-title`,
    statusGenerating: `${prefix}.status.generating`,
    statusGenerationFailed: `${prefix}.status.generation-failed`,
    validationWorkflowDescription: `${prefix}.validation.workflowDescription`,
    validationWorkflowTitle: `${prefix}.validation.workflowTitle`,
} as const satisfies Record<string, TranslationKey>;

export const getProfileTaskClassificationTranslationKey = (classification: string): TranslationKey => {
    if (classification === 'commodity' || classification === 'contribution') {
        return `${prefix}.classification.${classification}`;
    }

    return profileTaskTranslationKeys.unknownClassification;
};

export const getProfileTaskClassificationDescriptionTranslationKey = (
    classification: string,
): TranslationKey | undefined => {
    if (classification === 'commodity' || classification === 'contribution') {
        return `${prefix}.classification.${classification}-description`;
    }

    return undefined;
};
